var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41 1.823c-.412-.168-.52-.151-.61.008-.022.04.065.156.62.422.415.198.966.388 1.664.58-.933-.64-1.27-.845-1.675-1.01zm4.476 3.002a82.052 82.052 0 0 1-1.845-.397c-1.411-.323-2.447-.632-3.197-.99-1.152-.55-1.727-1.312-1.205-2.244C3.114.344 3.95.212 4.915.606c.58.236.963.48 2.248 1.367.158.11.275.19.39.267.84.57 1.403.883 1.866 1.015.852.243 1.466.424 1.87.552.214.068.373.122.485.166.075.03.134.056.19.088.065.036.065.036.187.15.219.295.219.295-.022.907-.33.332.355.457-3.243-.293z",
    fill: "#2A2825",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.176 1.823c.41-.168.52-.151.608.008.018.032.023.012-.079.106-.2.185-.597.392-1.158.598-.35.129-.715.245-1.139.361 1.004-.69 1.349-.902 1.768-1.073zm-.167 1.946c1.697-.624 2.575-1.434 1.937-2.575-.475-.85-1.311-.982-2.276-.588-.58.236-.964.48-2.248 1.367-.158.11-.275.19-.39.267-.84.57-1.403.883-1.866 1.015-.836.238-1.456.424-1.862.558-.213.07-.372.128-.483.176-.084.036-.15.07-.214.115-.084.058-.084.058-.227.26-.102.465-.102.465.206.835.334.242.516.21 3.211-.352 2.105-.439 3.186-.701 4.212-1.078z",
    fill: "#2A2825",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.325 7.941V4.223l15.35-.074v3.792a.784.784 0 0 0-.784.784v8.707c0 .582-.471 1.053-1.053 1.053H3.311a1.053 1.053 0 0 1-1.053-1.053v-9.49h-.933z",
    fill: "#FF7694"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD300",
    fillRule: "nonzero",
    d: "M7.429 3.832h3.187v14.425H7.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C90541",
    opacity: 0.5,
    d: "M2.692 8.282h12.661v3.5H2.693z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.5,
    d: "M1.647 4.47h14.751v1.462H1.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.975 8.621v8.32a1 1 0 0 0 1 1H14.07a1 1 0 0 0 1-1V8.62H2.975zm-1.328-.496h14.751v9.622c0 .738-.765 1.509-1.6 1.509H3.189c-.75 0-1.54-.771-1.54-1.51v-9.62z",
    fill: "#2A2825",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.898 4.908v2.665c0 .138.112.25.25.25h13.657a.25.25 0 0 0 .25-.25V4.908a.25.25 0 0 0-.25-.25H2.148a.25.25 0 0 0-.25.25zm-.25-1.565h14.75c.505 0 .835.295.835.806v4.275c0 .495-.4.715-.835.715H1.648c-.5 0-.915-.424-.915-.715V4.15c0-.29.62-.806.914-.806z",
    fill: "#2A2825",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.22ab1ad83caa78c60f2576187acd61b8.svg";
export { ForwardRef as ReactComponent };